import CreatedAt from './CreatedAt';
import Type from './Type';
import UnitPrice from './UnitPrice';
import NetPrice from './NetPrice';
import Count from './Count';
import Partner from './Partner';
import ReceiptNumber from './ReceiptNumber';

export const labels = {
  CreatedAt: 'Dátum',
  Type: 'Esemény',
  UnitPrice: 'Egységár',
  NetPrice: 'Nettó ár',
  Count: 'Mennyiség',
  Partner: 'Partner',
  ReceiptNumber: 'Bizonylatszám',
};

export const allColumns = [{
  value: 'CreatedAt',
}, {
  value: 'Type',
}, {
  value: 'UnitPrice',
}, {
  value: 'NetPrice',
}, {
  value: 'Count',
}, {
  value: 'Partner',
}, {
  value: 'ReceiptNumber',
}];

export const defaultColumns = [
  {
    value: 'CreatedAt',
    fixed: true,
  },
  {
    value: 'Type',
  },
  {
    value: 'ReceiptNumber',
  },
  {
    value: 'UnitPrice',
  },
  {
    value: 'NetPrice',
  },
  {
    value: 'Count',
  },
  {
    value: 'Partner',
  },
];

export const defaultSort = {
  prop: CreatedAt.propName,
  order: 'descending'
};

export default {
  CreatedAt,
  Type,
  UnitPrice,
  NetPrice,
  Count,
  Partner,
  ReceiptNumber,
};
